import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { FaHistory } from 'react-icons/fa';
import { BidHistoryContainer, BidHistoryList, BidHistoryItem, EmptyBids, } from '../../pages/AuctionHouse/AuctionDetail.styles';
const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(amount);
};
const formatRelativeTime = (timestamp) => {
    const now = Date.now();
    const then = new Date(timestamp).getTime();
    const diffMs = now - then;
    const diffSeconds = Math.floor(diffMs / 1000);
    if (diffSeconds < 5)
        return 'just now';
    if (diffSeconds < 60)
        return `${diffSeconds}s ago`;
    const diffMinutes = Math.floor(diffSeconds / 60);
    if (diffMinutes < 60)
        return `${diffMinutes}m ago`;
    const diffHours = Math.floor(diffMinutes / 60);
    if (diffHours < 24)
        return `${diffHours}h ago`;
    const diffDays = Math.floor(diffHours / 24);
    return `${diffDays}d ago`;
};
const BidHistory = ({ recentBids }) => {
    const listRef = useRef(null);
    const prevCountRef = useRef(recentBids.length);
    // Auto-scroll to top when new bid arrives (most recent is at top)
    useEffect(() => {
        if (recentBids.length > prevCountRef.current && listRef.current) {
            listRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        }
        prevCountRef.current = recentBids.length;
    }, [recentBids.length]);
    return (_jsxs(BidHistoryContainer, { children: [_jsxs("h3", { children: [_jsx(FaHistory, {}), "Bid History", recentBids.length > 0 && (_jsxs("span", { style: { fontSize: '12px', fontWeight: 400, color: 'var(--text-tertiary)', fontFamily: 'inherit' }, children: ["(", recentBids.length, ")"] }))] }), recentBids.length === 0 ? (_jsx(EmptyBids, { children: "No bids yet. Be the first to bid!" })) : (_jsx(BidHistoryList, { ref: listRef, children: recentBids.map((bid, index) => (_jsxs(BidHistoryItem, { "$isLatest": index === 0, children: [_jsxs("div", { className: "bid-bidder", children: [index === 0 && (_jsx("span", { style: { color: 'var(--accent-gold, #e6c068)', fontSize: '10px' }, children: "\u2605" })), bid.anonymousId] }), _jsx("span", { className: "bid-amount", children: formatCurrency(bid.amount) }), _jsx("span", { className: "bid-time", children: formatRelativeTime(bid.timestamp) })] }, `${bid.anonymousId}-${bid.timestamp}-${index}`))) }))] }));
};
export default BidHistory;
